import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTariffRegionList extends Layout {
    labelSearchRegion: Label;
    sourceTariffRegionLtlZipLoc: DataSource;
    tableRegionList: Table;
}
